import React from "react"
import { SiRedux } from "react-icons/si"

const Logo = () => {
	return (
		<div className="logo-wrap">
			<SiRedux className="redux-icon" />
			<h1>Playlist - Redux</h1>
		</div>
	)
}
export default Logo
